import {ProgressNavigationItem} from '@wba/models/progress-navigation-item';
import {ProgressNavItemsEnum} from '@wba/models/enums/progress-nav-items.enum';

export const ProgressNavigationListV2: ProgressNavigationItem[] = [
  {
    id: ProgressNavItemsEnum.BG,
    label: 'Bedarfsgemeinschaft',
    url: '/wba/vorabfragen/bedarfsgemeinschaft',
    icon: 'ba-icon-family',
    active: true,
    disabled: false,
    status: null,
    progressed: true,
    visible: true,
  },
  {
    id: ProgressNavItemsEnum.HG,
    label: 'Haushalt und Haushaltsgemeinschaft',
    url: '/wba/vorabfragen/haushaltsgemeinschaft',
    icon: 'ba-icon-private',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: true,
  },
  {
    id: ProgressNavItemsEnum.UMZUG,
    label: 'Umzug',
    url: '/wba/umzug',
    icon: 'ba-icon-employees-training',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: false,
  },
  {
    id: ProgressNavItemsEnum.KDU,
    label: 'Kosten der Unterkunft und Heizung',
    url: '/wba/kdu',
    icon: 'ba-icon-rent',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: false,
  },
  {
    id: ProgressNavItemsEnum.KONTOAUSZUEGE,
    label: 'Kontoauszüge',
    url: '/wba/kontoauszuege',
    icon: 'ba-icon-application',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: true,
  },
  {
    id: ProgressNavItemsEnum.EINKOMMEN,
    label: 'Einkommen',
    url: '/wba/einkommen',
    icon: 'ba-icon-money-added',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: true,
  },
  {
    id: ProgressNavItemsEnum.ABSETZUNGEN,
    label: 'Absetzungen',
    url: '/wba/absetzungen',
    icon: 'ba-icon-paper-update',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: true,
  },
  {
    id: ProgressNavItemsEnum.WEITERE_AENDERUNGEN,
    label: 'Weitere Änderungen',
    url: '/wba/weitere-aenderungen',
    icon: 'ba-icon-move-in',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: true,
  },
  {
    id: ProgressNavItemsEnum.ZUSAMMENFASSUNG,
    label: 'Zusammenfassung',
    url: '/wba/zusammenfassung',
    icon: 'ba-icon-message',
    active: false,
    disabled: true,
    status: null,
    progressed: false,
    visible: true,
  }
];
